module.exports = new __parcel__URL__("padlock-key.3d73e47c.svg").toString();